<template>
  <div>
    <!-- Info Banner -->
    <div class="form-info-banner">
      <h3 class="form-info-banner-title">
        Os campos com * são de preenchimento obrigatório
      </h3>
      <p class="form-info-banner-text">
        Caso queira, você poderá salvar e continuar depois.
      </p>
    </div>

    <!-- Seção: Declarações de Vínculo -->
    <section class="form-section">
      <div class="form-section-header">
        <LabelDisclaimer
          :TamanhoFonteLabel="'H5'"
          :NomeLabel="'Declarações de Vínculo do Cliente'"
          :Sessao="'Declarações'"
          :SubSessao="'Vinculo cliente'"
        />
      </div>
      <div class="form-section-content">
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >Você trabalha ou possui vínculo com a {{ nomeEmpresa }}?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="false"
                  name="VinculoRji"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.VinculoRji"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="true"
                  name="VinculoRji"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.VinculoRji"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >Você ou alguém de seu relacionamento exerce ou exerceu algum
              cargo público nos últimos 5 anos?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="false"
                  name="ConhecePoliticamenteExposta"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.ConhecePoliticamenteExposta"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="true"
                  name="ConhecePoliticamenteExposta"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.ConhecePoliticamenteExposta"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label" for="especificacao"
              >Se sim, especifique</label
            >
            <textarea
              @change="salvarAlteracoesLocalmente"
              v-model="localPJ.ConhecePoliticamenteExpostaDescricao"
              id="especificacao"
              class="field"
            ></textarea>
          </div>
        </div>
      </div>
    </section>
    <!-- Seção: Declaração de Propósitos -->
    <section class="form-section">
      <div class="form-section-header">
        <LabelDisclaimer
          :TamanhoFonteLabel="'H5'"
          :NomeLabel="'Declaração de Propósitos'"
          :Sessao="'Declarações'"
          :SubSessao="'Proposito'"
        />
      </div>
      <div class="form-section-content">
        <div class="form-grid-1">
          <div class="form-field">
            <p class="text-sm text-gray-700 dark:text-gray-300 mb-4">
              Em cumprimento ao disposto no artigo 2º, inciso III da Circular nº
              3.461/09, do Banco Central do Brasil, o abaixo assinado declara os
              propósitos e a natureza da relação de negócios que pretende manter
              com o(a) {{ nomeEmpresa }}*.
            </p>
          </div>
        </div>
        <div class="form-grid-1">
          <div class="form-field">
            <div class="form-checkbox-group form-checkbox-group-cols">
              <label class="form-checkbox-item">
                <input
                  type="checkbox"
                  id="cambio"
                  value="Câmbio"
                  name="Cambio"
                  class="form-checkbox-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.NegocioCambio"
                />
                <span class="form-checkbox-label">Câmbio</span>
              </label>
              <label class="form-checkbox-item">
                <input
                  type="checkbox"
                  id="operacoes_credito"
                  value="Operações de Crédito"
                  name="OperacoesCredito"
                  class="form-checkbox-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.NegocioOperacoesCredito"
                />
                <span class="form-checkbox-label">Operações de Crédito</span>
              </label>
              <label class="form-checkbox-item">
                <input
                  type="checkbox"
                  id="aplicacoes_investimentos"
                  value="Aplicações/Investimentos"
                  name="AplicacoesInvestimentos"
                  class="form-checkbox-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.NegocioAplicacoesInvestimentos"
                />
                <span class="form-checkbox-label"
                  >Aplicações/Investimentos</span
                >
              </label>
              <label class="form-checkbox-item">
                <input
                  type="checkbox"
                  id="operacoes_acessorias"
                  value="Operações Acessórias (prestação de serviços e/ou garantias)"
                  name="OperacoesAcessorias"
                  class="form-checkbox-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.NegocioAcessorios"
                />
                <span class="form-checkbox-label"
                  >Operações Acessórias (prestação de serviços e/ou
                  garantias)</span
                >
              </label>
              <label class="form-checkbox-item">
                <input
                  type="checkbox"
                  id="intermediacao_operacoes"
                  value="Intermediação de Operações (corretagem)"
                  name="IntermediacaoOperacoes"
                  class="form-checkbox-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.NegocioIntermediacao"
                />
                <span class="form-checkbox-label"
                  >Intermediação de Operações (corretagem)</span
                >
              </label>
              <label class="form-checkbox-item">
                <input
                  type="checkbox"
                  id="outros"
                  value="Outros"
                  name="Outros"
                  class="form-checkbox-input"
                  @change="
                    () => {
                      salvarAlteracoesLocalmente();
                      verificarOutros();
                    }
                  "
                  v-model="localPJ.NegocioOutros"
                />
                <span class="form-checkbox-label">Outros</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-grid-1">
          <div class="form-field">
            <label
              class="form-field-label form-field-label-required"
              for="especificar"
              >Especificar</label
            >
            <textarea
              @change="salvarAlteracoesLocalmente"
              v-model="localPJ.NegocioOutrosEspecificar"
              id="especificar"
              class="field"
              :disabled="!localPJ.NegocioOutros"
            ></textarea>
            <p class="form-field-hint">
              Caso os propósitos acima assinalados sejam alterados durante a
              vigência de nosso relacionamento com o(a) {{ nomeEmpresa }},
              informarei imediatamente, de forma a permitir a necessária
              adequação dos controles exigidos pelas autoridades competentes.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Seção: FATCA -->
    <section
      class="form-section"
      v-if="this.user?.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA"
    >
      <div class="form-section-header">
        <LabelDisclaimer
          :TamanhoFonteLabel="'H5'"
          :NomeLabel="'FATCA (Foreign Account Tax Compliance Act) de Vínculo do Cliente'"
          :Sessao="'Declarações'"
          :SubSessao="'FACTA'"
        />
      </div>
      <div class="form-section-content">
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >É Instituição Financeira Estrangeira (FFI) aderente ao
              FATCA?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="false"
                  name="Facta"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.Facta"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="true"
                  name="Facta"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.Facta"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-grid-2">
          <div class="form-field">
            <label class="form-field-label" for="numeroGiin"
              >Se sim, informar o nº GIIN</label
            >
            <input
              class="field"
              type="text"
              id="numeroGiin"
              @change="salvarAlteracoesLocalmente"
              v-model="localPJ.NumeroGiin"
            />
          </div>
          <div class="form-field">
            <label class="form-field-label" for="numeroGiinMotivos"
              >Caso não possua o nº GIIN, informar os motivos</label
            >
            <input
              class="field"
              type="text"
              id="numeroGiinMotivos"
              @change="salvarAlteracoesLocalmente"
              v-model="localPJ.NumeroGiinMotivos"
            />
          </div>
        </div>
        <div class="form-grid-2">
          <div class="form-field">
            <label class="form-field-label">Tem Sede ou Filial nos EUA?</label>
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="false"
                  name="SedeEua"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.SedeEua"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="true"
                  name="SedeEua"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.SedeEua"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
          <div class="form-field">
            <label class="form-field-label"
              >É Sociedade Constituída sob a Legislação dos EUA?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="false"
                  name="SociedadeEua"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.SociedadeEua"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="true"
                  name="SociedadeEua"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.SociedadeEua"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label"
              >Possui vínculo societário com alguma instituição
              estrangeira?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="false"
                  name="SocietarioInstituicaoEstrangeira"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.SocietarioInstituicaoEstrangeira"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="true"
                  name="SocietarioInstituicaoEstrangeira"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.SocietarioInstituicaoEstrangeira"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label" for="instituicaoEstrangeiraPaises"
              >Se sim, quais país(es)?</label
            >
            <input
              class="field"
              type="text"
              id="instituicaoEstrangeiraPaises"
              @change="salvarAlteracoesLocalmente"
              v-model="localPJ.SocietarioInstituicaoEstrangeiraEspecificacao"
            />
          </div>
        </div>
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label"
              >Possui alguma fonte de renda em Mercado Estrangeiro?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="false"
                  name="FonteRendaMercadoEstrangeiro"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.FonteRendaMercadoEstrangeiro"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="true"
                  name="FonteRendaMercadoEstrangeiro"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.FonteRendaMercadoEstrangeiro"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label" for="fonteRendaPaises"
              >Se sim, quais país(es)?</label
            >
            <input
              class="field"
              type="text"
              id="fonteRendaPaises"
              @change="salvarAlteracoesLocalmente"
              v-model="localPJ.FonteRendaMercadoEstrangeiroEspecificacao"
            />
          </div>
        </div>
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label"
              >Possui conta corrente com movimentação no exterior?</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="false"
                  name="ContaCorrenteExterior"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.ContaCorrenteExterior"
                />
                <span class="form-radio-label">Não</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="true"
                  name="ContaCorrenteExterior"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.ContaCorrenteExterior"
                />
                <span class="form-radio-label">Sim</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label" for="contaCorrentePaises"
              >Se sim, quais país(es)?</label
            >
            <input
              class="field"
              type="text"
              id="contaCorrentePaises"
              @change="salvarAlteracoesLocalmente"
              v-model="localPJ.ContaCorrenteExteriorEspecificacao"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Seção: Declarações -->
    <section class="form-section">
      <div class="form-section-header">
        <LabelDisclaimer
          :TamanhoFonteLabel="'H5'"
          :NomeLabel="'Declarações'"
          :Sessao="'Declarações'"
          :SubSessao="'Declarações'"
        />
      </div>
      <div class="form-section-content">
        <div class="form-grid-1">
          <div class="form-field">
            <label class="form-field-label form-field-label-required"
              >Declaro que opero por conta:</label
            >
            <div class="form-radio-group">
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="true"
                  name="OperaPorConta"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.OperaPorConta"
                />
                <span class="form-radio-label">Própria</span>
              </label>
              <label class="form-radio-item">
                <input
                  type="radio"
                  :value="false"
                  name="OperaPorConta"
                  class="form-radio-input"
                  @change="salvarAlteracoesLocalmente"
                  v-model="localPJ.OperaPorConta"
                />
                <span class="form-radio-label">de Terceiros</span>
              </label>
            </div>
          </div>
        </div>
        <div v-if="declaracoesCarregado">
          <DeclaracoesDocumentos />
        </div>
        <div v-else>
          <div
            v-if="!requisicaoFinalizada"
            style="z-index: 999"
            class="loading-overlay-div"
          >
            <div class="spinner"></div>
          </div>
        </div>
      </div>
    </section>

    <ModalAlerta
      :mostrar="modalAlerta.mostrar"
      :tipo="modalAlerta.tipo"
      :titulo="modalAlerta.titulo"
      :mensagem="modalAlerta.mensagem"
      @fechar="fecharModalAlerta"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DeclaracoesDocumentos from "./DeclaracoesDocumentos.vue";
import LabelDisclaimer from "@/components/LabelDisclaimer.vue";
import { TIPO_CLIENTE } from "@/constants/TipoClienteEnum";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";

export default {
  name: "CadastroPF_Declaracoes",
  props: ["informacoesDeclaracoes", "Edicao"],
  components: { LabelDisclaimer, DeclaracoesDocumentos, ModalAlerta },
  computed: {
    ...mapGetters({
      user: "auth/user",
      listaDocumentos: "GET_LISTA_DOCUMENTOS",
      listaDocumentosCliente: "GET_LISTA_DOCUMENTOS_CLIENTE",
      getConfiguracoes: "GET_CONFIGURACOES",
    }),
  },
  data() {
    return {
      TIPO_CLIENTE,
      localPJ: {},
      permitirAvancar: true,
      declaracoesCarregado: false,
      modalAlerta: {
        mostrar: false,
        tipo: "warning",
        titulo: "",
        mensagem: "",
      },
    };
  },
  watch: {
    informacoesDeclaracoes: {
      handler(newVal) {
        if (newVal) {
          this.localPJ = { ...newVal };
        }
      },
      immediate: true,
      deep: true,
    },
    listaDocumentosCliente() {
      //this.validarFormulario();
    },
    listaDocumentos(newVal) {
      if (newVal && newVal.length > 0) {
        this.declaracoesCarregado = true;
      }
    },
  },
  async mounted() {
    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;

    // Inicializar localPJ com dados da prop
    if (this.informacoesDeclaracoes) {
      this.localPJ = { ...this.informacoesDeclaracoes };
    }

    await this.fetchConfiguracao([
      "Obrigatoriedade - Pergunta: Declaração de propósito",
    ]);
    var chave = this.getConfiguracoes(
      "Obrigatoriedade - Pergunta: Declaração de propósito",
    );
    if (chave) {
      this.obrigatorioPerguntaDeclaracao = chave.Valor == "S" ? true : false;
    }

    this.loadDeclaracoesDocumentos();
    //this.validarFormulario();
  },
  methods: {
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    async proximaEtapa() {
      if (await this.validarFormulario(true)) {
        this.$store.commit("SET_PJ_SALVAR_INFO", true);
        this.$store.commit("SET_ETAPA_CADASTRO", 8);
        this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);
        this.salvarInformacoes();
      }
    },
    async validarFormulario(submeter) {
      this.permitirAvancar = true;
      var nomeDoCampo = "";

      if (!this.declaracoesCarregado) {
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: Aguarde o carregamento das declarações",
          mensagem: "Aguarde enquanto as declarações são carregadas",
        };
        this.permitirAvancar = false;
        return this.permitirAvancar;
      }

      // Validar campos obrigatórios
      if (
        this.localPJ.VinculoRji === null ||
        this.localPJ.VinculoRji === undefined
      ) {
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: campo obrigatório não preenchido",
          mensagem: `O campo "Você trabalha ou possui vínculo com a ${this.nomeEmpresa}?" é obrigatório.`,
        };
        this.permitirAvancar = false;
        return this.permitirAvancar;
      }

      if (
        this.localPJ.ConhecePoliticamenteExposta === null ||
        this.localPJ.ConhecePoliticamenteExposta === undefined
      ) {
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: campo obrigatório não preenchido",
          mensagem:
            'O campo "Você ou alguém de seu relacionamento exerce ou exerceu algum cargo público nos últimos 5 anos?" é obrigatório.',
        };
        this.permitirAvancar = false;
        return this.permitirAvancar;
      }

      if (
        this.localPJ.ConhecePoliticamenteExposta === "true" &&
        (this.localPJ.ConhecePoliticamenteExpostaDescricao === null ||
          this.localPJ.ConhecePoliticamenteExpostaDescricao.trim() === "")
      ) {
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: campo obrigatório não preenchido",
          mensagem:
            'O campo "Se sim, especifique" é obrigatório quando a resposta anterior for "Sim".',
        };
        this.permitirAvancar = false;
        return this.permitirAvancar;
      }

      if (this.user.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA) {
        if (this.localPJ.Facta === null || this.localPJ.Facta === undefined) {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Atenção: campo obrigatório não preenchido",
            mensagem:
              'O campo "É Instituição Financeira Estrangeira (FFI) aderente ao FATCA?" é obrigatório.',
          };
          this.permitirAvancar = false;
          return this.permitirAvancar;
        }
      }

      if (
        this.localPJ.OperaPorConta === null ||
        this.localPJ.OperaPorConta === undefined
      ) {
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: campo obrigatório não preenchido",
          mensagem: 'O campo "Declaro que opero por conta" é obrigatório.',
        };
        this.permitirAvancar = false;
        return this.permitirAvancar;
      }

      if (this.listaDocumentos != null) {
        if (this.listaDocumentosCliente == null) {
          this.permitirAvancar = false;
          return this.permitirAvancar;
        }
        if (this.listaDocumentos != null) {
          this.listaDocumentos.forEach((documentoObj) => {
            if (
              documentoObj.TipoCliente == this.user.TipoCliente &&
              documentoObj.Obrigatoriedade == "Sim"
            ) {
              if (!this.listaDocumentosCliente) {
                this.permitirAvancar = false;
                nomeDoCampo = documentoObj.NomeDocumento;
              } else if (
                !this.listaDocumentosCliente.some(
                  (p) =>
                    p != null &&
                    documentoObj != null &&
                    p.TemplateId === documentoObj.TemplateId,
                ) ||
                this.listaDocumentosCliente.some(
                  (p) =>
                    p != null &&
                    documentoObj != null &&
                    p.TemplateId === documentoObj.TemplateId &&
                    p.StatusAssinatura != "Assinado",
                )
              ) {
                this.permitirAvancar = false;
                nomeDoCampo = documentoObj.NomeDocumento;
              }
            }
          });
        }
      }
      if (submeter && nomeDoCampo != "") {
        this.modalAlerta = {
          mostrar: true,
          tipo: "warning",
          titulo: "Atenção: documento não assinado",
          mensagem: `O documento ${nomeDoCampo} é obrigatório e não foi assinado, aceite os termos para avançar`,
        };
        this.permitirAvancar = false;
        return this.permitirAvancar;
      }
      if (this.obrigatorioPerguntaDeclaracao) {
        const ExisteCheckboxSelecionado =
          this.localPJ.NegocioCambio ||
          this.localPJ.NegocioOperacoesCredito ||
          this.localPJ.NegocioAplicacoesInvestimentos ||
          this.localPJ.NegocioAcessorios ||
          this.localPJ.NegocioIntermediacao ||
          this.localPJ.NegocioOutros;
        const OutrosNegociosPreenchidos =
          !this.localPJ.NegocioOutros ||
          (this.localPJ.NegocioOutros &&
            (this.localPJ.NegocioOutrosEspecificar ?? "").trim() !== "");
        if (!ExisteCheckboxSelecionado) {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Atenção: pergunta obrigatória não informada",
            mensagem:
              "Pelo menos uma das opções disponíveis deve ser selecionada para o preenchimento do campo 'Declaração de Propósitos'.",
          };
          this.permitirAvancar = false;
          return this.permitirAvancar;
        } else if (!OutrosNegociosPreenchidos) {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Atenção: pergunta obrigatória não informada",
            mensagem:
              "O campo 'Especificar' é obrigatório quando 'Outros' está selecionado em Declaração de Propósitos.",
          };
          this.permitirAvancar = false;
          return this.permitirAvancar;
        }
      }
      this.permitirAvancar = true;
      return this.permitirAvancar;
    },
    salvarInformacoes() {
      this.$store.commit("SET_PJ_SALVAR_INFO", true);
    },
    salvarAlteracoesLocalmente() {
      this.$store.commit("SET_PJ_SALVAR_INFO_DECLARACOES", this.localPJ);
    },
    verificarOutros() {
      if (!this.localPJ.NegocioOutros) {
        this.localPJ.NegocioOutrosEspecificar = "";
      }
    },
    async loadDeclaracoesDocumentos() {
      this.declaracoesCarregado = false;
      if (this.listaDocumentos && this.listaDocumentos.length > 0) {
        this.declaracoesCarregado = true;
        return;
      }
      try {
        await this.$store.dispatch("FETCH_CONSULTA_LISTA_DOCUMENTOS");
        this.declaracoesCarregado =
          this.listaDocumentos && this.listaDocumentos.length > 0;
      } catch {
        this.declaracoesCarregado = false;
      }
    },
    fecharModalAlerta() {
      this.modalAlerta.mostrar = false;
    },
  },
};
</script>
